import { useEffect, useState } from "react";
import { Box, Divider, styled } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { useAuthContext } from "features/auth/AuthContext";
import MenuItems from "./MenuItems";
import NavItem from "./NavItem";

import logoPortrait from "assets/logo-portrait-white.svg";

const Nav = styled("nav")(({ theme }) => {
  return {
    "&.SideBar-root": {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      padding: theme.spacing(1),
      zIndex: 1000,
      boxShadow: "2px 0 4px #0004",
      ":not([data-open=true]) .MuiListItemText-root": {
        display: "none",
      },
    },
    "& .SideBar-header": {
      display: "flex",
      flexDirection: "column",
    },
    "& .SideBar-logo": {
      display: "block",
      marginInline: "auto",
      width: "3rem",
      marginBlock: theme.spacing(1),
    },
    "& .SideBar-items": {
      display: "flex",
      flexDirection: "column",
      justifyItems: "start",
      gap: theme.spacing(0.5),
      flexGrow: "1",
      backgroundColor: theme.palette.primary.main,
    },
    "& .SideBar-divider": {
      marginTop: theme.spacing(0.5),
    },
  };
});

type SideBarProps = { onLogout: () => void };

const SideBar: React.FC<SideBarProps> = (props) => {
  const { onLogout } = props;
  const { user } = useAuthContext();

  const [isMenuOpen, setIsMenuOpen] = useState(
    JSON.parse(localStorage.getItem("isMenuOpen") ?? "true")
  );

  useEffect(() => {
    localStorage.setItem("isMenuOpen", JSON.stringify(isMenuOpen));
  }, [isMenuOpen]);

  return (
    <Nav data-open={isMenuOpen} className="SideBar-root">
      <Box className="SideBar-header">
        <Box className="SideBar-logo" component="img" src={logoPortrait} alt="avs-logo" />

        <NavItem
          tooltip={{ title: isMenuOpen ? "Minimera" : "Expandera" }}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          icon={isMenuOpen ? <MenuOpenIcon /> : <MenuIcon />}
          sx={{ alignSelf: "start", justifySelf: "start" }}
        />
      </Box>

      <Box className="SideBar-items">
        <Divider color="black" className="SideBar-divider" />

        <MenuItems showTooltips={!isMenuOpen} />

        <NavItem
          to="/profile"
          sx={{ marginTop: "auto" }}
          icon={<AccountCircleIcon />}
          text={user?.userName}
          tooltip={!isMenuOpen && "Min profil"}
        />

        <NavItem
          onClick={onLogout}
          icon={<LogoutIcon />}
          text="Logga ut"
          tooltip={!isMenuOpen && "Logga ut"}
        />
      </Box>
    </Nav>
  );
};

export default SideBar;
